import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loading from "./Loading";
import Modal from "./Modal";
import { FaEdit } from "react-icons/fa";
const RecipeDetails = () => {
  const [previewImg, setPreviewImg] = useState(
    "https://media.istockphoto.com/id/1332339349/vector/click-to-add-icon.jpg?s=612x612&w=0&k=20&c=AV2zlEaC7W4NrSxFfjK9w6etv_iHdeZecIBGZ1KFies="
  );
  const [modalVisible, setModalVisible] = useState(false);
  const [saveBtn, setSaveBtn] = useState(false); //state of the save btn
  const btnVisibility = saveBtn ? "visible" : "hidden"; // conditional rendering of save btn
  const params = useParams();
  const password = "gina";
  const [recipeData, setRecipeData] = useState([]);
  const [id, setId] = useState(params.id);
  const [img, setImg] = useState("");
  //const to load image
  const [noImgId, setNoImgId] = useState("temp-img");
  //call for individual recipe
  const getData = () => {
    axios
      .get(`https://the-menu-server-a0c079ab1940.herokuapp.com/api/recipes/${id}`)
      .then((res) => setRecipeData(res.data));
  };

  //modal switches
  const openModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
  };
  // Function to update description state
  const updateDescriptionState = (newDescription) => {
    setRecipeData((prevRecipeData) => ({
      ...prevRecipeData,
      description: newDescription,
    }));
  };

  const postRecipe = () => {
    setNoImgId("loading-img");
    axios.put(`https://the-menu-server-a0c079ab1940.herokuapp.com/api/recipes/${params.id}`, {
      image: img,
    });
  };

  //convert image to string
  function convertToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setImg(reader.result);
        setPreviewImg(reader.result);
        setSaveBtn(true);
      };
      reader.onerror = (error) => {
        reject(error);
      };
    });
  }
  //handle image upload
  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertToBase64(file);
  };

  useEffect(() => {
    setId(params.id);
    getData();
  }, [recipeData, noImgId]);

  return (
    <>
      {recipeData.title ? (
        <div className="home-cnt">
          <h1 style={{ textAlign: "center", marginTop: "40px" }}>
            <div className="title-container">{recipeData.title}</div>
          </h1>
          {recipeData.note && (
            <div className="note">
              <h5>Note:</h5>
              <p>{recipeData.note}</p>
            </div>
          )}
          <div className="container-recipe">
            <div className="grid-container">
              <div className="column-left">
                <div className="recipe-card">
                  {recipeData.user && (
                    <div className="username">Recipe by: {recipeData.user}</div>
                  )}
                  {recipeData.image.url ? (
                    <img src={recipeData.image.url} />
                  ) : (
                    <div
                      style={{ backgroundImage: `url(${previewImg})` }}
                      className={noImgId}
                    >
                      <input
                        onChange={(e) => handleFileUpload(e)}
                        type="file"
                        accept=".jpeg, .png , .jpg"
                        
                      />
                      <button
                        onClick={postRecipe}
                        style={{
                          position: "absolute",
                          bottom: "0",
                          visibility: btnVisibility,
                          borderRadius:'10px',
                          color:'#fff',
                          border:'none',
                          padding:'4px 5px',
                          backgroundColor:'dodgerblue'
                          
                        }}
                      >
                        Update Image
                      </button>
                    </div>
                  )}
                </div>
              </div>
              {modalVisible && (
                <Modal
                  updateDescriptionState={updateDescriptionState}
                  props={recipeData}
                  onClose={closeModal}
                />
              )}
              <div className="column-right">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <h3 style={{ marginRight: "auto" }}>Ingredients:</h3>
                  <FaEdit />
                </div>
                <ul>
                  {recipeData.ingredients.map((ingredient, index) => (
                    <li key={index}>{ingredient}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="description-row">
              <div
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <h3 style={{ marginRight: "auto" }}>Cooking Description:</h3>
                <FaEdit onClick={openModal} style={{ cursor: "pointer" }} />
              </div>
              {recipeData.description && <p>{recipeData.description}</p>}
            </div>
          </div>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default RecipeDetails;
